/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkUpdateShiftsDataBaseData } from './BulkUpdateShiftsDataBaseData';
import {
    BulkUpdateShiftsDataBaseDataFromJSON,
    BulkUpdateShiftsDataBaseDataFromJSONTyped,
    BulkUpdateShiftsDataBaseDataToJSON,
    BulkUpdateShiftsDataBaseDataToJSONTyped,
} from './BulkUpdateShiftsDataBaseData';

/**
 * 
 * @export
 * @interface BulkUpdateShiftsDataShiftData
 */
export interface BulkUpdateShiftsDataShiftData {
    /**
     * The ids of shifts in this set to update
     * @type {Array<number>}
     * @memberof BulkUpdateShiftsDataShiftData
     */
    shiftIds: Array<number>;
    /**
     * 
     * @type {BulkUpdateShiftsDataBaseData}
     * @memberof BulkUpdateShiftsDataShiftData
     */
    data: BulkUpdateShiftsDataBaseData;
}

/**
 * Check if a given object implements the BulkUpdateShiftsDataShiftData interface.
 */
export function instanceOfBulkUpdateShiftsDataShiftData(value: object): value is BulkUpdateShiftsDataShiftData {
    if (!('shiftIds' in value) || value['shiftIds'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BulkUpdateShiftsDataShiftDataFromJSON(json: any): BulkUpdateShiftsDataShiftData {
    return BulkUpdateShiftsDataShiftDataFromJSONTyped(json, false);
}

export function BulkUpdateShiftsDataShiftDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateShiftsDataShiftData {
    if (json == null) {
        return json;
    }
    return {
        
        'shiftIds': json['shiftIds'],
        'data': BulkUpdateShiftsDataBaseDataFromJSON(json['data']),
    };
}

  export function BulkUpdateShiftsDataShiftDataToJSON(json: any): BulkUpdateShiftsDataShiftData {
      return BulkUpdateShiftsDataShiftDataToJSONTyped(json, false);
  }

  export function BulkUpdateShiftsDataShiftDataToJSONTyped(value?: BulkUpdateShiftsDataShiftData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shiftIds': value['shiftIds'],
        'data': BulkUpdateShiftsDataBaseDataToJSON(value['data']),
    };
}

